import store from '../reducers';
import { securityActions } from '../reducers/security';
import { clearHeadersAndTokens } from '../actions/security';
import { localStorageConstants, notificationType } from '../constants/globals';
import { createNotification } from '../utils';
import { decryptDataCryptoJS } from './security/security-utils';

export const filterSuccessAction = (response, action, dispatch, messages) => {
  dispatch(action(response.data));
  response.data.content?.length === 0 &&
    messages &&
    createNotification(
      notificationType.info,
      messages.title,
      messages.notFoundMessage
    );
};

export const errorAction = (
  error,
  action,
  dispatch,
  messages,
  notificationDuration
) => {
  if (error?.response?.status === 401) {
    tokenExpiredAction();
  } else if (error?.response?.status === 503) {
    serviceUnavailableAction();
  } else {
    createNotification(
      notificationType.error,
      messages?.errorTitle,
      error?.response?.data?.message,
      notificationDuration
    );
  }
  dispatch(action(error?.response?.data));
};

//TODO srediti prevode
export const tokenExpiredAction = () => {
  createNotification(notificationType.error, 'Greška', 'Token je istekao');
  clearHeadersAndTokens();
  window.location.replace('/');
};

export const serviceUnavailableAction = () => {
  createNotification(notificationType.error, 'Greška', 'Servis nije dostupan');
};

export const decodeAndSetActions = (decodedToken) => {
  const encriptedActions = localStorage.getItem(
    localStorageConstants.ALLOWED_ACTIONS
  );
  if (encriptedActions) {
    const { secretKey } = decodedToken || {};
    const decryptedData = decryptDataCryptoJS(encriptedActions, secretKey);
    store.dispatch(securityActions.setAllowedActions(decryptedData));
  }
};
